import {Mail, MapPin, Phone} from "lucide-react";

function Contacts() {
    return (
        <section className="py-12 px-4 bg-white">
            <div className="max-w-7xl mx-auto">
                <div className="bg-slate-900 rounded-[3rem] p-8 md:p-16 text-white grid lg:grid-cols-2 gap-16 items-center">
                    <div className="space-y-8">
                        <h3 className="text-3xl md:text-4xl font-extrabold leading-tight">Vous avez des questions ?<br/><span className="text-primary">On est là pour vous aider.</span></h3>
                        <p className="text-slate-400 text-lg">
                            Notre équipe est disponible pour vous accompagner dans l'usage quotidien du logiciel au sein de votre cabinet.
                        </p>
                        {/*Contacts info here if the form uncommented*/}
                    </div>

                    <div className="space-y-4">
                        {/*<div className="flex items-center gap-4">
                            <div className="w-12 h-12 bg-slate-800 rounded-xl flex items-center justify-center text-primary"><Phone size={24} /></div>
                            <div><p className="text-sm text-slate-500">Appelez-nous</p><p className="font-bold">+212 5 22 00 00 00</p></div>
                        </div>*/}
                        <div className="flex items-center gap-4">
                            <div className="w-12 h-12 bg-slate-800 rounded-xl flex items-center justify-center text-primary"><Mail size={24} /></div>
                            <div><p className="text-sm text-slate-500">Email</p><p className="font-bold"> <a href={"mailto:contact@dentotek.ma"}>contact@dentotek.ma</a></p></div>
                        </div>
                        <div className="flex items-center gap-4">
                            <div className="w-12 h-12 bg-slate-800 rounded-xl flex items-center justify-center text-primary"><MapPin size={24} /></div>
                            <div><p className="text-sm text-slate-500">Localisation</p><p className="font-bold">Casablanca, Maroc</p></div>
                        </div>
                    </div>

                    {/*<form className="bg-white p-8 rounded-3xl space-y-4">
                        <h4 className="text-slate-900 text-xl font-bold mb-6 text-center">Demander à être rappelé</h4>
                        <input type="text" placeholder="Votre nom complet" className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl text-slate-900 focus:outline-primary" />
                        <input type="tel" placeholder="N° de téléphone" className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl text-slate-900 focus:outline-primary" />
                        <input type="email" placeholder="Adresse Email" className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl text-slate-900 focus:outline-primary" />
                        <button className="w-full bg-primary text-white py-4 rounded-xl font-bold hover:bg-blue-700 transition-all shadow-lg">
                            Envoyer ma demande
                        </button>
                        <p className="text-[10px] text-slate-400 text-center mt-4">
                            En envoyant ce formulaire, vous acceptez d'être contacté par nos conseillers.
                        </p>
                    </form>*/}
                </div>
            </div>
        </section>
    );
}

export default Contacts;